import { Check, ArrowRight, TrendingUp } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const BENEFITS = [
  "Find jobs near you",
  "Choose the jobs you want",
  "Set your own price",
  "Build your reputation",
  "Get paid securely",
];

export default function ForTaskers() {
  return (
    <section id="become-a-tasker" data-testid="for-taskers-section" className="py-20 md:py-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal className="relative order-2 lg:order-1">
          <div className="relative rounded-[2rem] overflow-hidden shadow-2xl shadow-navy/20 aspect-[4/3] bg-slate-200 -rotate-1">
            <img
              src="https://images.pexels.com/photos/7491098/pexels-photo-7491098.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=940"
              alt="An independent tasker completing a home service job"
              loading="lazy"
              className="w-full h-full object-cover"
              data-testid="taskers-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/50 via-transparent to-transparent" />
          </div>
          <div
            data-testid="taskers-earnings-chip"
            className="absolute -bottom-6 left-6 sm:left-10 bg-white rounded-2xl shadow-xl shadow-navy/15 border border-slate-100 px-5 py-4 flex items-center gap-3 animate-float-slow"
          >
            <span className="w-10 h-10 rounded-full bg-teal/10 grid place-items-center">
              <TrendingUp className="w-5 h-5 text-teal" />
            </span>
            <div>
              <p className="font-display font-extrabold text-navy text-lg leading-none">£240</p>
              <p className="text-[11px] text-slate-500 mt-1">earned this week</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="order-1 lg:order-2">
          <Eyebrow>For taskers</Eyebrow>
          <h2 className="mt-4 font-display font-extrabold tracking-tight text-navy text-3xl sm:text-4xl lg:text-5xl">
            Turn your skills into income.
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed max-w-md">
            Find local jobs, choose the work you want and keep more of what you earn.
          </p>
          <ul className="mt-7 space-y-3.5" data-testid="taskers-benefits-list">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-center gap-3 text-navy font-medium">
                <span className="w-6 h-6 rounded-full bg-teal grid place-items-center shrink-0">
                  <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />
                </span>
                {b}
              </li>
            ))}
          </ul>
          <a
            href="#app"
            data-testid="taskers-become-tasker-btn"
            className="group mt-9 inline-flex items-center gap-2 bg-navy hover:bg-navy-dark text-white font-semibold px-8 py-4 rounded-full transition-colors duration-200"
          >
            Become a Tasker
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
